import { ElementType, GlobalConfig } from "../types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

const createHeaderContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    padding: "15px 30px",
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  responsiveStyles: {
    tablet: {
      padding: "15px 10px",
    },
    mobile: {
      padding: "15px 10px",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        maxWidth: "1270px",
        margin: "0 auto",
      },
      children: [
        {
          id: generateId(),
          type: "logo" as ElementType,
          styles: {
            backgroundColor: "background",
            padding: "0 0 0 0",
            display: "flex",
            justifyContent: "space-between",
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "FORTI",
              styles: {
                fontSize: "32px",
                fontWeight: "bold",
                color: "forground",
                margin: "0",
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "GOLD",
              styles: {
                fontSize: "32px",
                fontWeight: "normal",
                color: "forground",
                margin: "0",
              },
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            padding: "0 0 0 0",
            display: "flex",
            alignItems: "center",
            gap: "64px",
          },
          responsiveStyles: {
            tablet: {
              display: "none",
            },
            mobile: {
              display: "none",
            },
          },
          children: [
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "About",
              styles: {
                backgroudColor: "#ffffff00",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "600",
                color: "forground",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Benefits",
              styles: {
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "600",
                color: "forground",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "FAQ",
              styles: {
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "600",
                color: "forground",
              },
            },
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "ORDER NOW",
              styles: {
                backgroundColor: "#FBBC04",
                color: "forground",
                padding: "16px 24px",
                borderRadius: "16px",
                fontWeight: "600",
                fontStyle: "normal",
                fontSize: "20px",
                cursor: "pointer",
              },
            },
          ],
        },
        //Hamburger Button
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "none", // Hidden on desktop
            width: "44px",
            height: "44px",
            borderRadius: "50%",
            border: "none",
            alignItems: "center",
            justifyContent: "center",
            padding: "0",
            cursor: "pointer",
            marginLeft: "12px",
          },
          responsiveStyles: {
            tablet: {
              display: "flex",
            },
            mobile: {
              display: "flex",
            },
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/hamburger.svg",
              alt: "avatar1",
              styles: {
                width: "20px",
                height: "20px",
                objectContain: "contain",
                display: "block",
              },
            },
          ],
        },
      ],
    },
  ],
});

const createInfoHeaderSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    padding: "93px 10px",
    backgroundColor: "#F7F7F7",
    color: "#000",
    backdropFilter: "blur(14.3px)",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: { padding: "60px 10px" },
    mobile: { padding: "16px 10px" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1382px",
        width: "100%",
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
          },
          responsiveStyles: {
            tablet: {
              flexDirection: "column",
              gap: "10px",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            },
            mobile: {
              flexDirection: "column",
              gap: "10px",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            },
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Privacy Policy",
              styles: {
                fontFamily: "Manrope, sans-serif",
                fontSize: "70px",
                fontStyle: "normal",
                fontWeight: 800,
                lineHeight: "80px",
                letterSpacing: "-2.1px",
                textAlign: "left",
                margin: 0,
                color: "#000",
              },
              responsiveStyles: {
                desktop: { fontSize: "60px", lineHeight: "60px" },
                tablet: { fontSize: "50px", lineHeight: "50px" },
                mobile: {
                  fontSize: "45px",
                  lineHeight: "45px",
                  fontWeight: 700,
                },
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Date Effective: April 13, 2025",
              styles: {
                fontFamily: "Manrope, sans-serif",
                fontSize: "40px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "80px",
                letterSpacing: "-1.2px",
                textAlign: "left",
                margin: 0,
                color: "#000",
              },
              responsiveStyles: {
                desktop: { fontSize: "34px", lineHeight: "34px" },
                tablet: { fontSize: "34px", lineHeight: "34px" },
                mobile: { fontSize: "25px", lineHeight: "25px" },
              },
            },
          ],
        },
      ],
    },
  ],
});

type HeadingSize = "large" | "small";

const privacyPolicySections: {
  heading: string;
  headingSize: HeadingSize;
  contents: string[];
}[] = [
  {
    heading: "Privacy Policy",
    headingSize: "large",
    contents: [
      "This Privacy Policy outlines how FortiGold.com (“we,” “our,” or “us”) collects, uses, and protects the personal information of our users. By accessing or using this site, you agree to the practices described in this document. We take your privacy seriously and are committed to safeguarding the information you share with us.",
    ],
  },
  {
    heading: "Information We Collect",
    headingSize: "small",
    contents: [
      "When you interact with our website, we collect both personal and non-personal information. Personal information is collected when you voluntarily provide it to us—for example, when you place an order, sign up for a newsletter, or contact customer support. This information may include your name, email address, shipping address, billing address, and payment details.",
      "In addition, we collect certain data automatically as you navigate our site. This includes your IP address, browser type, device type, referral pages, and pages visited. These technical details help us understand how visitors use our site, and they assist us in optimizing user experience and website performance.",
    ],
  },
  {
    heading: "How We Use Your Information",
    headingSize: "small",
    contents: [
      "We use the information we collect to process your transactions, deliver the products you purchase, respond to your inquiries, and provide a more personalized shopping experience. We may also use your information to send email communications such as order confirmations, product updates, or promotional messages. You can unsubscribe from marketing emails at any time.",
      "Additionally, we may use anonymized or aggregated data for research, analytics, and marketing purposes. This helps us understand buying behavior, website engagement, and market trends—without identifying you personally.",
    ],
  },
  {
    heading: "Sharing and Disclosure",
    headingSize: "small",
    contents: [
      "We do not sell your personal information. However, we may share it with third parties in order to operate our business effectively. This includes partners such as payment processors, email marketing services, shipping providers, customer support platforms, and analytics vendors. These partners are required to maintain the confidentiality and security of your information and are only authorized to use it as necessary to perform services on our behalf.",
      "We may also disclose your information if required to comply with applicable laws or respond to valid legal requests, such as subpoenas or court orders. In the event of a business sale, merger, or acquisition, your data may be transferred as part of the assets involved in the transaction.",
    ],
  },
  {
    heading: "Cookies and Tracking Technologies",
    headingSize: "small",
    contents: [
      "We use cookies and other tracking technologies to enhance your browsing experience and support essential website functions. Cookies help us remember your preferences, improve site performance, and deliver relevant advertisements. We may also use tools like Google Analytics, Meta (Facebook) Pixel, and similar platforms to understand how visitors engage with our content and advertising.",
      "You may disable cookies through your browser settings at any time, though doing so may impact your ability to use certain features on our site.",
    ],
  },
  {
    heading: "Your Rights and Choices",
    headingSize: "small",
    contents: [
      "Depending on your location, you may have rights under privacy laws such as the General Data Protection Regulation (GDPR) or the California Consumer Privacy Act (CCPA). These rights may include access to your personal data, the right to correct or delete your information, and the right to restrict or object to certain processing activities.",
      "To exercise any of these rights, please contact us at support@fortigold.com. We will respond to requests within a reasonable time frame, and in accordance with applicable laws.",
    ],
  },
  {
    heading: "Data Security",
    headingSize: "small",
    contents: [
      "We implement a range of security measures to protect your personal data, including encryption, secure servers, and access restrictions. While we strive to protect your information, no method of transmission over the internet or electronic storage is 100% secure. We encourage you to take your own precautions as well, such as using strong passwords and keeping your login credentials private.",
    ],
  },
  {
    heading: "Children's Privacy",
    headingSize: "small",
    contents: [
      "FortiGold.com is not intended for children under the age of 13. We do not knowingly collect personal data from anyone under 13 years old. If we become aware that a child has submitted personal information without verified parental consent, we will delete the data immediately.",
    ],
  },
  {
    heading: "Changes to This Policy",
    headingSize: "small",
    contents: [
      "We may update this Privacy Policy from time to time to reflect changes in our practices, services, or legal requirements. Any updates will be posted to this page with an updated effective date. By continuing to use our site after changes are posted, you accept those modifications.",
    ],
  },
  {
    heading: "Contact Us",
    headingSize: "small",
    contents: [
      "If you have questions, feedback, or concerns about this Privacy Policy or how we handle your information, we encourage you to reach out. You can email us at <b>support@fortigold.com</b>.",
      "We appreciate your trust and thank you for choosing FortiGold.",
    ],
  },
];

const getHeadingStyles = (size: HeadingSize) =>
  size === "large"
    ? {
        color: "#000",
        fontFamily: "Poppins, sans-serif",
        fontSize: "55px",
        fontWeight: 700,
        lineHeight: "40px",
        letterSpacing: "-0.55px",
      }
    : {
        color: "#000",
        fontFamily: "Poppins, sans-serif",
        fontSize: "40px",
        fontWeight: 700,
        lineHeight: "40px",
        letterSpacing: "-0.4px",
      };

const getHeadingResponsive = (size: HeadingSize) =>
  size === "large"
    ? {
        desktop: { fontSize: "45px", lineHeight: "45px" },
        mobile: { fontSize: "40px", lineHeight: "40px" },
      }
    : {
        desktop: { fontSize: "34px", lineHeight: "34px" },
        mobile: { fontSize: "30px", lineHeight: "30px" },
      };

const privacyPolicyParagraphStyles = {
  color: "forground",
  fontFamily: "Poppins, sans-serif",
  fontSize: "28px",
  fontWeight: 400,
  lineHeight: "40px",
  letterSpacing: "-0.28px",
};

const privacyPolicyParagraphResponsive = {
  desktop: { fontSize: "24px", lineHeight: "36px" },
  mobile: { fontSize: "18px", lineHeight: "24px" },
};

const createPointersLinstingSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    padding: "120px 0",
    width: "100%",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { padding: "80px 0", maxWidth: "95%", margin: "0 auto" },
    mobile: { padding: "40px 0", maxWidth: "95%", margin: "0 auto" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1339px",
        margin: "0 auto",
        width: "100%",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            gap: "60px 0",
            color: "#000",
          },
          responsiveStyles: {
            tablet: { gap: "40px 0" },
          },
          children: privacyPolicySections.map((section) => ({
            id: generateId(),
            type: "container" as ElementType,
            styles: { display: "flex", flexDirection: "column", gap: "30px 0" },
            responsiveStyles: {
              tablet: { gap: "22px 0" },
              mobile: { gap: "18px 0" },
            },
            children: [
              {
                id: generateId(),
                type: "heading" as ElementType,
                content: section.heading,
                styles: getHeadingStyles(section.headingSize),
                responsiveStyles: getHeadingResponsive(section.headingSize),
              },
              {
                id: generateId(),
                type: "container" as ElementType,
                styles: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px 0",
                },
                responsiveStyles: {
                  desktop: { gap: "18px 0" },
                  mobile: { gap: "10px 0" },
                },
                children: section.contents.map((content) => ({
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content,
                  styles: privacyPolicyParagraphStyles,
                  typography: "Body",
                  responsiveStyles: privacyPolicyParagraphResponsive,
                })),
              },
            ],
          })),
        },
      ],
    },
  ],
});

const createScientificReferencesSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "100px 0 72px 0",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { margin: "72px 0 36px 0" },
    mobile: { margin: "40px 0 32px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1334px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0px",
      },
      responsiveStyles: {
        tablet: { gap: "18px" },
        mobile: { gap: "12px" },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Scientific References:",
          styles: {
            color: "#000",
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontSize: "34px",
            fontWeight: 400,
            lineHeight: "80px",
            letterSpacing: "-1.35px",
            margin: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          responsiveStyles: {
            mobile: { fontSize: "22px", lineHeight: "25px" },
          },
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "35px",
            height: "100px",
          },
          responsiveStyles: {
            tablet: { gap: "24px", height: "auto" },
            mobile: { gap: "20px", height: "auto" },
          },
          children: [
            ...[1, 2, 3, 4].map((i) => ({
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                maxWidth: "258px",
                width: "100%",
              },
              responsiveStyles: {
                tablet: { maxWidth: "220px" },
                mobile: { maxWidth: "167px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/scientificReferencesSection1.png",
                  alt: `Reference Logo ${i}`,
                  styles: {
                    width: "100%",
                    objectFit: "contain",
                  },
                },
              ],
            })),
          ],
        },
      ],
    },
  ],
});

const createScientificRefListingSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "60px 0 72px 0",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { margin: "32px 0" },
    mobile: { margin: "24px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1334px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0px",
      },
      responsiveStyles: {
        tablet: { gap: "18px", maxWidth: "95%" },
        mobile: { gap: "12px", maxWidth: "95%" },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "24px",
          },
          responsiveStyles: {
            tablet: { gap: "18px", flexDirection: "column" },
            mobile: { gap: "12px", flexDirection: "column" },
          },
          children: [
            // First Col
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "calc(50% - 12px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "16px",
              },
              responsiveStyles: {
                tablet: { width: "100%" },
                mobile: { width: "100%" },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
              ],
            },
            // Second Col
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "calc(50% - 12px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "16px",
              },
              responsiveStyles: {
                tablet: { width: "100%" },
                mobile: { width: "100%" },
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content:
                        "<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline;'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>",
                      styles: {
                        color: "rgba(0, 0, 0, 0.70)",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createFooterMenuSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "primary",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "100%",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            height: "100px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "0 72px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: {
              gap: "0 24px",
            },
            mobile: {
              flexDirection: "column",
              gap: "28px 16px",
              height: "auto",
              padding: "28px 0",
            },
          },
          children: [
            // Privacy
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Privacy",
              href: "/privacy-policy",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Terms & Conditions
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Terms & Conditions",
              href: "/terms-and-conditions",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Disclaimer
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Disclaimer",
              href: "/disclaimer",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Product Label (trigger, not a link)
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "Product Label",
              // href: "#product-label",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
                cursor: "pointer",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
              triggerPopup: "fortigold-label-popup",
              // You can add a custom property for JS trigger if needed
            },
            // Returns & Refunds
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Returns & Refunds",
              href: "/returns-and-refunds",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Contact
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Contact",
              href: "/contact-us",
              styles: {
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

const createFooterEndSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "background",
    margin: 0,
    padding: 0,
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "12px",
        padding: "60px 0 0",
      },
      responsiveStyles: {
        mobile: {
          padding: "0 15px",
          margin: "30px auto 0",
        },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. The information presented on this site is for informational purposes only and is not a substitute for advice from your physician or other healthcare professional. Always consult with a qualified healthcare provider before beginning any diet, supplement, or exercise program.",
          styles: {
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.60)",
            fontFamily: "Poppins, sans-serif",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "28px",
            letterSpacing: "-0.28px",
          },
          responsiveStyles: {
            mobile: {
              fontSize: "16px",
            },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Individual results may vary. Testimonials and reviews appearing on this site reflect real-life experiences of individuals who used our products. However, results may not be typical and are not guaranteed.",
          styles: {
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.60)",
            fontFamily: "Poppins, sans-serif",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "28px",
            letterSpacing: "-0.28px",
          },
          responsiveStyles: {
            mobile: {
              fontSize: "16px",
            },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Copyright © 2024 – 2025 FortiGold. All Rights Reserved.",
          styles: {
            padding: "30px 0",
            color: "rgba(0, 0, 0, 0.60)",
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontSize: "22px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "45px",
            letterSpacing: "-0.22px",
          },
          responsiveStyles: {
            tablet: {
              padding: "10px 0",
              fontSize: "12px",
            },
            mobile: {
              padding: "10px 0",
              fontSize: "12px",
            },
          },
        },
      ],
    },
  ],
});

export const template1Privacy = (globalConfig: GlobalConfig) => {
  return {
    header: createHeaderContainer(globalConfig),
    infoHeaderSection: createInfoHeaderSection(globalConfig),
    pointersListingsSection: createPointersLinstingSection(globalConfig),
    scientificReferencesSection:
      createScientificReferencesSection(globalConfig),
    scientificRefListingSection:
      createScientificRefListingSection(globalConfig),
    footerMenuSection: createFooterMenuSection(globalConfig),
    footerEndSection: createFooterEndSection(globalConfig),
  };
};
